import React from 'react';
import {
  Modal,
  ModalConfirm,
} from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import useEditBuildingModal from './hooks';
import type { EditBuildingModalProps } from './hooks';

const EditBuildingModal = (props: EditBuildingModalProps) => {
  const { open, openConfirm } = props;
  const {
    ReactHookFormProps,
    fields,
    modalProps,
    confirmModalProps,
    handleCancel,
  } = useEditBuildingModal(props);

  return (
    <>
      <Modal open={open} onClose={handleCancel} {...modalProps}>
        <Form ReactHookFormProps={ReactHookFormProps} fields={fields} />
      </Modal>
      <ModalConfirm open={openConfirm} {...confirmModalProps} />
    </>
  );
};

export default EditBuildingModal;
